import Notification from '~/components/common/Notification'
import SelectRole from '~/components/logic-common/SelectRole'

export default ({ store }, inject) => {
  inject('notify', Notification)
  inject('selectRole', (exp) => {
    if (store.getters.isLogin) {
      return SelectRole(exp)
    } else {
      store.commit('app/setLoginPop', true)
      return Promise.reject(new Error('need login'))
    }
  })
}
